module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.7655/img/provider-ctas-blob-1x.png"